import React from "react";
import { Typography, Link, Box } from "@mui/joy";
function Copyright(_props: any) {
  return (
    <Typography style={{ position: "relative" }}>
      <Link
        href="https://www.gacitua.com.ar/"
        rel="Proveedor del servicio noreferrer"
        target="_blank"
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          justifyContent: { xs: "center", sm: "flex-start" },
        }}
      >
        <Typography
          level="title-lg"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // Asegura que todo esté centrado horizontalmente
            flexWrap: "wrap", // Para que se ajuste en pantallas pequeñas
            fontSize: { xs: "0.9rem", md: "1rem" }, // Ajuste de tamaño de texto según el tamaño de pantalla
          }}
        >
          <Typography
            color="neutral"
            sx={{ fontSize: { xs: "0.8rem", md: "1rem" } }}
          >
            {"Powered by "}
          </Typography>
          <img
            src={"assets/logoGacitua.png"}
            alt="logo"
            style={{
              width: "20px",
              height: "20px",
              marginLeft: "4px",
              marginRight: "4px",
              // Ajusta el tamaño del logo según el tamaño de la pantalla
              //width: "auto",
              //height: { xs: "16px", md: "20px" }, // Tamaño responsivo del logo
            }}
          />
          <Typography sx={{ fontSize: { xs: "0.8rem", md: "1rem" } }}>
            {" Gacitua & Asociados"}
          </Typography>
        </Typography>
      </Link>
    </Typography>
  );
}

interface FooterProps {
  style?: React.CSSProperties;
}

const Footer: React.FC<FooterProps> = ({ style }) => {
  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
        bottom: 0,
        left: 0,
        display: "flex",
        justifyContent: "center",
        backgroundColor: "background.paper",
        py: 2,
        ...style,
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
      }}
    >
      <Copyright />
    </Box>
  );
};

export default Footer;
